document.addEventListener("DOMContentLoaded", function () {
  const backgroundContainer = document.querySelector("[data-js-background-section]");
  if (!backgroundContainer) return;

  const mobileQuery = window.matchMedia("(max-width: 875px)");

  function getDocumentTop(element) {
    const rect = element.getBoundingClientRect();
    return rect.top + (window.scrollY || window.pageYOffset);
  }

  function getDocumentHeight() {
    return Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.body.clientHeight,
      document.documentElement.clientHeight
    );
  }

  function updateBackgroundHeight() {
    const start = getDocumentTop(backgroundContainer);

    if (mobileQuery.matches) {
      const fullPageHeight = getDocumentHeight();
      const height = Math.max(fullPageHeight - start, window.innerHeight);
      backgroundContainer.style.height = `${Math.ceil(height)}px`;
      return;
    }

    const footerMarker = document.querySelector(".social_links_footer_container");
    if (!footerMarker) return;

    const footerTop = getDocumentTop(footerMarker);
    const height = Math.max(footerTop - start, window.innerHeight);
    backgroundContainer.style.height = `${Math.ceil(height)}px`;
  }

  function debounce(callback, wait) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => callback.apply(this, args), wait);
    };
  }

  const refresh = debounce(updateBackgroundHeight, 80);

  refresh();
  window.addEventListener("load", refresh);
  window.addEventListener("resize", refresh);
  mobileQuery.addEventListener("change", refresh);

  const resizeObserver = new ResizeObserver(refresh);
  resizeObserver.observe(document.body);

  const footerMarker = document.querySelector(".social_links_footer_container");
  if (footerMarker) resizeObserver.observe(footerMarker);

  setTimeout(refresh, 300);
  setTimeout(refresh, 1200);
});
